import { Component, OnInit, Output, Input, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, NgForm } from '@angular/forms';
import { SelectItem, Message } from 'primeng';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng';
import { IDriver } from '../../interfaces/driver';
import { NoEmptyString } from '../../interfaces/no-empty-string.validator';
import { IUserOrganisationLevel } from '../../interfaces/user-organisation-level';
import { IDriverService } from '../../services/driver.service';
import { OrganisationsService } from '../../services/organisations.service';

@Component({
  templateUrl: './driver-details.component.html',
})
export class DriverDetailsComponent implements OnInit {
  public driverForm: UntypedFormGroup;
  public firstName: UntypedFormControl;
  public surname: UntypedFormControl;
  public nickName: UntypedFormControl;
  public mobileNumber: UntypedFormControl;
  public drivingLicenceNumber: UntypedFormControl;

  public driver: IDriver;

  title = '';
  public id: number;
  public uLevel: IUserOrganisationLevel;
  public isSupplierIndividual: boolean = false;
  public accessDetail: any = null;

  constructor(
    private driverService: IDriverService,
    private router: Router,
    private organisationsService: OrganisationsService,
    private activatedRoute: ActivatedRoute,
    public messageService: MessageService,
  ) {}

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.id = params['id'];
    });

    this.firstName = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(20), NoEmptyString]),
    );
    this.surname = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(20), NoEmptyString]),
    );
    this.nickName = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(20), NoEmptyString]),
    );
    this.mobileNumber = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(20), NoEmptyString]),
    );
    this.drivingLicenceNumber = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(16), NoEmptyString]),
    );

    this.driverForm = new UntypedFormGroup({
      firstName: this.firstName,
      surname: this.surname,
      nickName: this.nickName,
      mobileNumber: this.mobileNumber,
      drivingLicenceNumber: this.drivingLicenceNumber,
    });

    this.driverService
      .getAccessDetails(this.id)
      .then((x) => {
        this.accessDetail = x;
        if (this.accessDetail && this.accessDetail.hasAccess) {
          this.organisationsService.getUserOrganisationLevel().then((resp) => {
            this.uLevel = resp;
          });

          this.organisationsService.getCurrentUserOrgSubTypeId().then((orgSubType) => {
            this.isSupplierIndividual = orgSubType == 1 ? true : false;
          });

          if (this.id == 0) {
            this.title = 'New Driver';
            return;
          } else {
            this.title = 'Edit Driver';
          }

          this.driverService.get(this.id).then((result) => {
            if (!result) {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Driver not found',
              });
              setTimeout(function () {
                this.l_msgs = [];
              }, 2000);
            }

            this.driver = result;
            this.setFormGroupValues();
          });
        }
      })
      .catch((err) => {
        this.accessDetail = { hasAccess: false };
      });
  }

  setFormGroupValues() {
    if (this.driver) {
      this.firstName.setValue(this.driver.firstName);
      this.surname.setValue(this.driver.surname);
      this.nickName.setValue(this.driver.nickName);
      this.mobileNumber.setValue(this.driver.mobileNumber);
      this.drivingLicenceNumber.setValue(this.driver.drivingLicenceNumber);
    }
  }

  save(formValues) {
    var obj = {
      id: this.id,
      depotId: 0,
      firstName: formValues.firstName,
      surname: formValues.surname,
      nickName: formValues.nickName,
      mobileNumber: formValues.mobileNumber,
      drivingLicenceNumber: formValues.drivingLicenceNumber,
    };

    // The "Driver added/updated" toast comes from the service; the driver's password is sent by SMS only
    this.driverService
      .saveDriver(obj)
      .then((smsSent: boolean) => {
        if (smsSent === false) {
          this.messageService.add({
            severity: 'warn',
            summary: 'SMS not sent',
            detail:
              'The driver was added but the SMS with their password could not be sent. Open the driver and use Reset Code to send a new one.',
          });
        }

        if (this.id == 0) {
          this.router.navigate(['app/drivers']);
        }
      })
      .catch((err) => {
        const message =
          err?.error?.Message ||
          err?.error?.message ||
          'An error occurred while saving the driver.';
        this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
      });
  }

  ResetCode() {
    this.driverService.resetCode(this.id).then((smsSent: boolean) => {
      if (smsSent) {
        this.messageService.add({
          severity: 'success',
          summary: 'Password reset',
          detail: 'A new password has been sent to the driver by SMS.',
        });
      } else {
        this.messageService.add({
          severity: 'warn',
          summary: 'SMS not sent',
          detail: 'The password was reset but the SMS could not be sent. Please try again.',
        });
      }
    });
  }

  Cancel() {
    this.router.navigate(['app/drivers']);
  }
}
